module.exports = __webpack_public_path__ + "797440e0043960108d9fc2c9af948cf1.png";